import { PoweredByEWebinar } from '$/components/Logo';
import config from '$/config';
import { ClassNames, css } from '@emotion/react';
import React from 'react';
import { withWebinarPlayerContext } from '../context';
import { MaxScaledRoomWidth } from '../useScaledRoomScale';
import { useLocalI18n } from '$/hooks/useLocalI18n';
import { cssDimensionsForRef } from '$/utils/image';
import { useImageSrcFromRef } from '$/hooks/useImageSrcFromRef';

export const PoweredByFooter: React.FC = withWebinarPlayerContext(
  ['ewebinar'],
  'PoweredByFooter'
)(({ context }) => {
  const localI18n = useLocalI18n(context.ewebinar?.viewerRoomSettings.language ?? 'en');
  return (
    <ClassNames>
      {({ css }): React.ReactElement => {
        return (
          <PoweredByEWebinar
            i18nProvided={localI18n}
            logoVersion='normal'
            vertical
            className={css`
              margin-top: 4rem;
              margin-bottom: 1rem;
            `}
            hideBranding={context.ewebinar.team.settings.hideBranding}
            teamId={context.ewebinar.team.id}
          />
        );
      }}
    </ClassNames>
  );
});

export const CustomerLogo: React.FC<{ className?: string }> = withWebinarPlayerContext(
  ['ewebinar'],
  'CustomerLogo'
)(({ className, context }) => {
  const { ewebinar } = context;
  if (!ewebinar.logoMediaRef) return null;

  const logoMediaUrl = useImageSrcFromRef(ewebinar.logoMediaRef, {
    w: config.LOGO_MAX_WIDTH * 1.6,
    h: config.LOGO_MAX_HEIGHT * 1.6,
  });
  return (
    <img
      src={logoMediaUrl}
      css={css`
        ${cssDimensionsForRef(ewebinar.logoMediaRef, {
          maxWidth: config.LOGO_MAX_WIDTH * 1.6,
          maxHeight: config.LOGO_MAX_HEIGHT * 1.6,
        })}
      `}
      className={className}
    />
  );
});

export const CustomerLogoAndTitle: React.FC = withWebinarPlayerContext(
  ['ewebinar'],
  'CustomerLogo'
)(({ context }) => {
  const { ewebinar } = context;

  return (
    <div
      className='flex flex-col justify-between items-center'
      css={css`
        max-width: ${MaxScaledRoomWidth}px;
      `}
    >
      <CustomerLogo
        css={css`
          margin-top: 1rem;
          margin-bottom: 1rem;
          background-position: bottom center;
        `}
      />
      <div className='text-4xl mb-2e md:mb-3e leading-tight text-center'>{ewebinar.title}</div>
    </div>
  );
});

export const CustomerLogoFooter: React.FC = withWebinarPlayerContext(
  ['dimensions'],
  'CustomerLogoFooter'
)(({ context }) => {
  const { dimensions } = context;
  const maxHeight = Math.max(
    0,
    dimensions.videoControlsArea.bottomBar.height -
      dimensions.videoControlsArea.bottomBar.paddingY -
      22
  );
  return (
    <CustomerLogo
      css={css`
        max-height: ${maxHeight}px;
        width: auto;
      `}
    />
  );
});

export class RoomPartsBase {
  public headerComponent(): React.FC | null {
    return null;
  }

  public bodyComponent(): React.FC | null {
    return null;
  }

  public footerComponent(): React.FC | null {
    return null;
  }

  public stageComponent(): { component: React.FC; zIndex?: number } | null {
    return null;
  }
}

export class LogoAndTitleRoomArea extends RoomPartsBase {
  public headerComponent(): React.FC | null {
    return CustomerLogoAndTitle;
  }
}
